var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsoleActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 16,
    fill: "url(#paint0_linear_15263_36606)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15263_36606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8613 25.1601C26.4739 25.1601 27.7812 23.8528 27.7812 22.2402C27.7812 20.6276 26.4739 19.3203 24.8613 19.3203C23.2487 19.3203 21.9414 20.6276 21.9414 22.2402C21.9414 23.8528 23.2487 25.1601 24.8613 25.1601Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6097 20.1331V26.309C34.6052 26.7661 34.51 27.2178 34.3297 27.6379C34.1494 28.058 33.8876 28.4381 33.5593 28.7563L31.1121 31.2035L27.3729 34.9427C26.7511 35.5462 25.9248 35.8933 25.0585 35.9147C24.1923 35.9361 23.3498 35.6303 22.699 35.0582L18.5922 31.4766L16.5545 29.6701C16.1891 29.3459 15.8963 28.9481 15.6954 28.5028C15.4945 28.0575 15.3899 27.5748 15.3887 27.0863V20.3537C15.392 19.7075 15.5769 19.0754 15.9223 18.5293C16.2678 17.9833 16.7598 17.5454 17.3423 17.2657L23.4447 14.3773C23.8846 14.174 24.362 14.0643 24.8466 14.0553C25.3312 14.0463 25.8123 14.138 26.2596 14.3248L32.488 16.9611C33.1165 17.2196 33.6539 17.6592 34.0317 18.2241C34.4095 18.789 34.6107 19.4535 34.6097 20.1331Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1537 31.1984L27.4146 34.9375C26.7906 35.5531 25.9556 35.9076 25.0794 35.9291C24.2033 35.9506 23.3519 35.6373 22.6986 35.0531L18.5918 31.4715C19.4105 30.5956 20.4036 29.901 21.5071 29.4325C22.6106 28.9639 23.8001 28.7318 24.9988 28.7511C27.2936 28.7196 29.5071 29.5997 31.1537 31.1984V31.1984Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15263_36606",
    x1: 50,
    y1: 0.00000160187,
    x2: -3.75,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443569,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15263_36606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3217,
    height: 24,
    fill: "white",
    transform: "translate(14.3379 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoleActive);
export default __webpack_public_path__ + "static/media/console-active.474ad9f8ee541943af6cf9c633f839ec.svg";
export { ForwardRef as ReactComponent };